import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import DetailListItem from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import onboardingStyles from '../../../../../../Onboarding/Pages/Survey/SurveyStep/StepLibrary/RiskTolerance/riskToleranceResultLayoutStyles';

const styles = (theme) => ({
  ...onboardingStyles(theme),
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  secondaryText: {
    ...onboardingStyles(theme).secondaryText,
    textAlign: 'justify',
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  results: {
    width: '100%',
  },
  surveyStepHeader: {
    padding: 0,
  },
  surveyStepHeaderTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  surveyStepHeaderSubtitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginTop: 0,
    marginBottom: theme.spacing(4),
  },
  headerIcon: {
    marginBottom: theme.spacing(4),
  },
});

function Layout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      <SurveyStepHeader
        titleTest={'wizard-step-title'}
        title={resource.attr('primaryText')}
        classes={{
          root: classes.surveyStepHeader,
          title: classes.surveyStepHeaderTitle,
          subtitle: classes.surveyStepHeaderSubtitle,
        }}
      />
      <Typography
        className={classes.secondaryText}
        color="primaryGray"
      >
        {resource.attr('secondaryText')}

      </Typography>
      <div className={classes.results}>
        {resource.attr('clients')?.resources().list().map((client) => (
          <DetailListItem
            key={client.id()}
            className={classes.resultItem}
            resource={client}
          />
        ))}
      </div>
    </div>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
